import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {SingleSuggestion} from './SingleISugesstion';
import styles from '../CommonCitations/style.module.scss';

interface Props {
  data: any[];
  store?: CurrentPageStore;
  isQueried?: boolean;
  customCallback?: () => void;
}


export const InternalLinksSuggestions = observer(({data, store, isQueried, customCallback}: Props) => {
  return <>
    <DropdownsContainer>
      {data?.length ?
        data?.map((suggestion, id) => (
          <SingleSuggestion key={`${id}-${suggestion.url}`} link={suggestion} customCallback={customCallback}/>
        )) : isQueried ?
          <div className={styles.emptyDataBox}>
            <span className={styles.emptyDataTitle}>No Internal Link Suggestions found that match your search.</span>
          </div> :
          store?.content?.targetKeywords?.length === 0 ?
            <div className={styles.emptyDataBox}>
              <span className={styles.emptyDataTitle}>Please add Target Keywords to get Internal Link Suggestions.</span>
            </div> : <div className={styles.emptyDataBox}>
              <span className={styles.emptyDataTitle}>No Internal Link Suggestions found for these Target Keywords.</span>
            </div>}
    </DropdownsContainer>

  </>;
});


const DropdownsContainer = styled.div`
  background-color: #2D2F34;
  max-height: 340px;
  overflow-y: auto;
  padding-right: 15px;
  padding-left: 15px;

  // For Internet Explorer
  scrollbar-face-color: rgba(138,138,138,0.32);
  scrollbar-track-color: rgba(138,138,138,0.12);

  // For Google Chrome
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(138,138,138,0.32);
  }

  &::-webkit-scrollbar-track {
    background: rgba(138,138,138,0.12);
  }
`;

